// src/shared/components/ui/popover.tsx
import * as React from 'react'
import * as RadixPopover from '@radix-ui/react-popover'
import clsx from 'classnames'

export const Popover = RadixPopover.Root
export const PopoverTrigger = RadixPopover.Trigger

export const PopoverContent = React.forwardRef<
  HTMLDivElement,
  RadixPopover.PopoverContentProps
>(({ className, sideOffset = 5, ...props }, ref) => (
  <RadixPopover.Portal>
    <RadixPopover.Content
      ref={ref}
      sideOffset={sideOffset}
      className={clsx(
        'z-50 bg-neutral-800 border border-neutral-800 rounded-md p-4 shadow-lg',
        className
      )}
      {...props}
    >
      {props.children}
      <RadixPopover.Arrow className="fill-neutral-800" />
    </RadixPopover.Content>
  </RadixPopover.Portal>
))
